import { SolidEyeSvg, SolidHeartSvg } from '@/assets/Icons';
import DorsaImage from '@/components/dorsaImage/DorsaImage';
import { IMAGE_SHAPES, IMAGE_SIZES } from '@/components/dorsaImage/imageTypes';

const UserSubmissionsVideoCover = ({
    handleClick,
    containerClassName,
    hasTitle = false,
    cover,
    likeCount,
    viewCount,
    title,
    isLoading
}) => {
    return (
        <div className={`user-recent-submissions-video-cover-container ${containerClassName} `}>
            <div className={`user-recent-submissions-cover-container`} onClick={handleClick}>
                {isLoading ? (
                    <div className="user-recent-submissions-video-cover card-skeleton" />
                ) : (
                    <>
                        <DorsaImage
                            src={cover}
                            className="user-recent-submissions-video-cover"
                            config={{
                                shape: IMAGE_SHAPES.VERTICAL,
                                size: IMAGE_SIZES.SIZE_1
                            }}
                        />
                        <div className="linear-gradiant ">
                            <div className="user-recent-submissions-video-cover-info">
                                <div className="user-recent-submissions-cover-item">
                                    <SolidEyeSvg />
                                    {viewCount}
                                </div>
                                <div className="user-recent-submissions-cover-item">
                                    <SolidHeartSvg />
                                    {likeCount}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {hasTitle && <span className="user-recent-submissions-video-cover-title">{title}</span>}
        </div>
    );
};

export default UserSubmissionsVideoCover;
